// // This MUST be the first line before any Angular imports
// const nonceMeta = document.querySelector('meta[name="csp-nonce"]');
// if (!nonceMeta) {
//     // Create meta tag if it doesn't exist (Lambda injects nonce into script tags directly)
//     const meta = document.createElement('meta');
//     meta.name = 'csp-nonce';
//     document.head.appendChild(meta);
// }

// // Set webpack nonce for dynamically loaded chunks
// const nonceFromScript = document.querySelector('script[nonce]')?.getAttribute('nonce');
// if (nonceFromScript) {
//     (window as any).__webpack_nonce__ = nonceFromScript;
// }


import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';

// Get nonce from meta tag (injected by Lambda)
const nonceMeta = document.querySelector('meta[name="csp-nonce"]');
const nonce = nonceMeta?.getAttribute('content');

if (nonce) {
  // Set webpack nonce for dynamic chunks
  (window as any).__webpack_nonce__ = nonce;
  
  // Also set Angular's global nonce
  (window as any).ngCspNonce = nonce;
}

if(environment.production) {
  enableProdMode();
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
